<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id" :salaLudicaId="tipo.Id">{{tipo.Nombre}} una sala lúica</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id" :salaLudicaId="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} las salas lúdicas</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Ninguna.Id" :value="tipo.Id" :salaLudicaId="tipo.Id">{{enumeraciones.tiposDeSelect.Ninguna.Nombre}} sala lúdica</option>
        <option v-for="SalaLudica in SalasLudicas" :value="SalaLudica.salaLudicaId" :key="SalaLudica.salaLudicaId">{{SalaLudica.nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        SalasLudicas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      //this.$store.dispatch("A_SIPSIC_Catalogo_Establecer013SalaLudica", parametros);
    },
    methods: {
      cargaCatalogoSalasLudicas() {
        console.log(this.parametros)
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.SIPSIC.catalogos.C013SalasLudicas, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.SalasLudicas = respuesta.data.salasLudicas;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.SalasLudicas = respuesta.data.SalasLudicas.filter(cond => this.parametros.filtros.some(salaLudica => salaLudica == cond.SalaLudicaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        this.$store.dispatch("A_SIPSIC_Catalogo_Establecer013SalaLudica", parametros);
        this.$emit("valorParaElPadre", [evento,this.SalasLudicas[evento.target.selectedIndex -1]]);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoSalasLudicas();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Comun/Catalogos/013SalasLudicas.vue